<template>
    <div>
        <v-card class="ma-2">
            <v-card-title  class="teal white--text">Daftar Pengguna Rekanan
                <v-spacer />
                <!--<v-btn @click.stop="dlgUserAdd"><v-icon left>add</v-icon>Tambah</v-btn>-->
            </v-card-title>

            <v-card-title>
                <v-text-field v-model="table.search" prepend-icon="search" label="Search" single-line hide-details></v-text-field>
            </v-card-title>

            <v-data-table class="elevation-1" :search="table.search" :headers="table.headers" :items="listVendor" :items-per-page="10" :single-select="true" item-key="id" height="400"
            fixed-header>
                <template v-slot:item.roles="{item}">
                    {{ getValueItem(itemsUserRoles, item.roles) }} 
                </template>
                <template v-slot:item.status="{item}">
                    <v-chip class="" :color="getColor(item.status)" small>{{ getValueItem(itemsUserStatus, item.status) }}</v-chip>
                </template>
                <template v-slot:item.actions="{item}">
                    <v-btn icon color="cyan" @click="openFormResetPassword(item)"> <v-icon>mdi-account-key</v-icon> </v-btn>
                    <v-btn icon color="cyan" @click="openFormChangeStatus(item)"> <v-icon>mdi-account-check</v-icon> </v-btn>
                </template>
            </v-data-table>

            <v-dialog v-model="dlgResetPassword" max-width="400px" persistent>
                <v-card dark>
                <v-card-title>KIRIM RESET PASSWORD</v-card-title>
                <v-card-text>User ID: {{userResetPassword.login}}</v-card-text>
                <v-card-text>Nama: {{userResetPassword.nama}}</v-card-text>
                <v-card-text>Email: {{userResetPassword.email}}</v-card-text>
                <v-card-actions>
                    <v-btn color="success" @click="submitFormResetPassword()">Kirim</v-btn>
                    <v-btn color="orange" @click="dlgResetPassword = false">Batal</v-btn>
                </v-card-actions>
                </v-card>
            </v-dialog>

            <v-dialog v-model="dlgChangeStatus" max-width="400px" persistent>
                <v-card dark>
                <v-card-title>UBAH STATUS</v-card-title>
                <v-card-text>User ID: {{userChangeStatus.login}}</v-card-text>
                <v-card-text>Nama: {{userChangeStatus.nama}}</v-card-text>
                <v-card-text>Email: {{userChangeStatus.email}}</v-card-text>
                <v-container>
                    <v-row>
                        <v-col cols="5"><v-select v-model="userChangeStatus.status" :items="itemsUserStatus" label="Status" outlined></v-select></v-col>
                    </v-row>
                </v-container>
                <v-card-actions>
                    <v-btn color="success" @click="submitFormChangeStatus()">Simpan</v-btn>
                    <v-btn color="orange" @click="dlgChangeStatus = false">Batal</v-btn>
                </v-card-actions>
                </v-card>
            </v-dialog>

        </v-card>

        <v-dialog v-model="submitting" persistent max-width="300px">
            <v-card dark>
                <v-card-title>Sedang diproses</v-card-title>
                <v-card-text> <v-progress-linear color="cyan" indeterminate /> </v-card-text>
            </v-card>
        </v-dialog>

    </div>
</template>


<script>

const API_URL = process.env.VUE_APP_ROOT_API
import axios from 'axios'
import { getValueItem, itemsUserRoles, itemsUserStatus } from "./../../lib/viewLib"


export default {

    data() {
        return {
            itemsUserRoles: itemsUserRoles,
            itemsUserStatus: itemsUserStatus,
            listVendor: [],

            // Data table
            table: {
                search: "",
                headers: [
                    { text: "User ID", value: "login", class: "green accent-2 subtitle-2" },
                    { text: "Email", value: "email", class: "green accent-2 subtitle-2" },
                    { text: "Nama", value: "nama", class: "green accent-2 subtitle-2" },
                    { text: "Jabatan", value: "jabatan", class: "green accent-2 subtitle-2" },
                    { text: "Roles", value: "roles", class: "green accent-2 subtitle-2" },
                    { text: "Status", value: "status", class: "green accent-2 subtitle-2" },
                    { text: "", value: "actions", sortable: false, class: "green accent-2 subtitle-2" }
                ],
            },

            // Reset password
            dlgResetPassword: false,
            userResetPassword: {
                id: null,
                login: "",
                nama: "",
                email: ""
            },

            // Change status
            dlgChangeStatus: false,
            userChangeStatus: {
                id: null,
                login: "",
                nama: "",
                email: "",
                status: "I"
            },

            submitting: false,

        }
    }, // data

    created() {
        axios.get(`${API_URL}/userman/vendor`)
        .then( (response) => {
            this.listVendor = response.data;
        })
        .catch( (error) => {
            console.error(error);
        });

    }, // created
    
    methods: {
        getValueItem: getValueItem,
        
        getColor: function(status) {
            let color = ''
            switch (status) {
                case 'A': color = 'success'; break;
                case 'S': color = 'warning'; break;
                case 'I': color = 'error'; break;
                default: color = 'primary'; break;
            }
            return color
        },

        openFormResetPassword: function(user) {
            if (user == null) return;

            this.dlgResetPassword = true;
            this.userResetPassword.id = user.id;
            this.userResetPassword.login = user.login;
            this.userResetPassword.nama = user.nama;
            this.userResetPassword.email = user.email;
        },

        submitFormResetPassword: async function() {
            if (this.userResetPassword.id == null) return;

            const data = {
                id: this.userResetPassword.id,
                userId: this.userResetPassword.login,
                email: this.userResetPassword.email
            };

            this.$store.dispatch('displayProgBar');  
            this.submitting = true;

            await axios.post(API_URL + "/userman/forget", data)
            .then( () => {
                this.$store.dispatch('displayAlert', { color: 'success', message: `Ubah password berhasil dikirim` });
            })
            .catch( (err) => {
                console.error(err);
                this.$store.dispatch('displayAlert', { color: 'error', message: err });
            })
            .finally( () => {
                this.$store.dispatch('closeProgBar');
                this.submitting = false;
                window.scroll(0,0);
            });

            this.dlgResetPassword = false;
        },

        openFormChangeStatus: function(user) {
            if (user == null) return;

            this.dlgChangeStatus = true;
            this.userChangeStatus.id = user.id;
            this.userChangeStatus.login = user.login;
            this.userChangeStatus.nama = user.nama;
            this.userChangeStatus.email = user.email;
            this.userChangeStatus.status = user.status;
        },

        submitFormChangeStatus: async function() {
            if (this.userChangeStatus.id == null) return;

            this.$store.dispatch('displayProgBar')  
            this.submitting = true;

            await axios.put(API_URL + "/userman/status/" + this.userChangeStatus.id, this.userChangeStatus)
            .then( () => {
                this.$store.dispatch('displayAlert', { color: 'success', message: `Ubah status user berhasil disimpan`});
                
                const index = this.listVendor.findIndex(element => element.id === this.userChangeStatus.id);
                if (index != -1) {
                    this.listVendor[index].status = this.userChangeStatus.status;
                }
            })
            .catch( (err) => {
                console.error(err);
                this.$store.dispatch('displayAlert', { color: 'error', message: err });
            })
            .finally( () => {
                this.$store.dispatch('closeProgBar');
                this.submitting = false;
                window.scroll(0,0);
            });

            this.dlgChangeStatus = false;
        },

    }, // methods
}

</script>
